import $http from './http'
import config from './config'
export default {
  name: 'hotelpolicy',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getProductLists(data) {
    return $http.post(this.getUrl(`/Product/list`), data, {failTips: false});
  },
  getIHotelList(data) {
    return $http.post(this.getUrl(`/IHotelPolicy/IHotelList`), data);
  },
  getProductInfo(data) {
    return $http.post(this.getUrl(`/HotelPolicy/ProductInfo`), data);
  },
  IHotelInfo(data) {
    return $http.post(this.getUrl(`/IHotelPolicy/IHotelInfo`), data);
  },
  getProductDetail(data) {
    return $http.post(this.getUrl(`/Product/ProductDetail`), data);
  },
  Citylist(id) {
    return $http.get(this.getUrl(`/HotelPolicy/Citylist/${id}`));
  },
  //获取酒店特色、设施
  getThemeFacilityList(data){
    return $http.post(this.getUrl(`/product/SearchFacilities?filterCode=${data}`))
  },
  //获取商圈
  getCityBusiness(data){
    return $http.post(this.getUrl('/product/CityBusiness'), data);
  },
  //获取风控
  getRiskInfos(data){
    return $http.post(this.getUrl('/riskinfo/SearchRiskInfo'),data,{ failTips: false })
  }
}



// WEBPACK FOOTER //
// ./src/apis/hotelPolicyApi.js